
import React, {Component} from 'react'
import { browserHistory, Link } from 'react-router'
import BlueLogo from '../assets/newblacklogo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import './navbar.css'
import { BsChevronDown } from 'react-icons4/bs';


export default class GlobalNav extends Component {

  constructor() {
    super()
    this.state = {
      mobileMenu: false,
      showMore: false
    }
    this.setState = this.setState.bind(this)
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
    document.body.scroll = "";
  }

  render() {
    const { noSignup } = this.props
  
    return (
      <div> 
        <div className="acquisition-banner">We're excited to announce that Streamable has been acquired by Hopin! <a href="https://streamable.com/resources/streamable-acquired-by-hopin/" target="_blank">Read more →</a></div>      
        <nav className="global-nav navbar navbar-default">
          {this.state.mobileMenu ?
            <div className="mobile-overlay">
              <a href='#' className='close' onClick={
                e => {
                  e.preventDefault()
                  this.setState({mobileMenu: false, showMore: false})

                  document.body.style.overflow = 'unset';
                  document.body.scroll = "";
                }
              }>
                ✕
              </a>
              <Link to="/signup">Sign Up</Link>
              <Link to="/login">Log In</Link>
              <Link to="/pricing">Pricing</Link>    
              <span>Tools</span>  
              <div className="tools">
                <a href="/trim-video">Trim Video</a>
                <a href="/compress-video">Compress Video</a>
                <a href="/mute-video">Mute Video</a>
                {this.state.showMore ?
                <div>
                  <a href="/clipper">Clip from URL</a>
                  <a href="/rotate-video">Rotate Video</a>
                  <a href="/upload-video">Upload Video</a>
                  <a href="/crop-video">Crop Video</a>
                  <a href="/embed-video">Embed Video</a>
                </div>
                : 
                <a className="more" href="#" onClick={_ => this.setState({showMore: true})}><BsChevronDown /> See all</a>
                }
              </div>
              <a href="https://support.streamable.com/">Support</a>
              <a href="https://careers.streamable.com/">Careers</a>
            </div>
          : ''}
          <ul className="nav navbar-nav">
            <li>
              <a href="https://streamable.com" className="nav-btn logo-btn">
                <img className="logo" src={BlueLogo} role="presentation" />
              </a>
            </li>
            <li style={{flex: 1}}>
              <div className="tools-dropdown-container">
                <span className="nav-btn features-btn">
                  Tools <FontAwesomeIcon icon={faCaretDown} />
                </span>
                <div className="tools-dropdown-menu-container">
                  <div className="tools-dropdown-menu">
                    <a href="/upload-video">Upload Video</a>
                    <a href="/clipper">Clip from URL</a>
                    <a href="/trim-video">Trim Video</a>
                    <a href="/rotate-video">Rotate Video</a>
                    <a href="/mute-video">Mute Video</a>
                    <a href="/crop-video">Crop Video</a>
                    <a href="/compress-video">Compress Video</a>
                    <a href="/embed-video">Embed Video</a>
                  </div>
                </div>
              </div>
              <Link to="/pricing?src_internal=landing-navbar-link" className="nav-btn pricing-btn">
                Pricing
              </Link>
              <a href="https://support.streamable.com" className="nav-btn support-btn">
                Support
              </a>
            </li>
            <li>
              <Link to="/login" className="nav-btn login-btn">
                Log In
              </Link>
              {noSignup ? '' :
              <Link to="/signup?signup_src=landing" className="nav-btn signup-btn">
                Sign up <span class="nomobile">for free</span>
              </Link>
              }
            </li>
            <li className='mobilemenu'>
              <a href="#" className="nav-btn" onClick={
                e => {
                  e.preventDefault()
                  this.setState({mobileMenu: true, showMore: false})

                  document.body.style.overflow = 'hidden';
                  document.body.scroll = "no";
                }
              }>Menu <FontAwesomeIcon icon={faCaretDown} /></a>
            </li>
          </ul>
        </nav>
      </div>
    )
  }
}